module.exports = __webpack_public_path__ + "img/History_Line_16px_Icon_0.6.b2edaa96.svg";